// extracted by mini-css-extract-plugin
export default {"main_div":"AddCompanies_main_div__Sad7L","heading":"AddCompanies_heading__JCSmf","add_content_div":"AddCompanies_add_content_div__+45ua"};